/**
 * Pokladna vystavené B2B nabídky (KAN-1658).
 *
 * Z nabídky se objednává STANDARDNÍ pokladnou — stejné kroky, validace a
 * e-maily jako u košíku. Liší se jen zdroj položek: místo košíku
 * zákazníka je to objednávka nabídky, s cenou zamčenou z nabídky.
 *
 * Pokladna to pozná z adresy (``/{lang}/checkout?quote=<public_id>``) a
 * ``lib/api.ts`` pak na každé volání přiloží hlavičku
 * :data:`QUOTE_CHECKOUT_HEADER`. Backend ji čte jen na čtecích
 * endpointech pokladny a na ``POST /checkout``
 * (``app/services/quote_checkout.py``); úpravy košíku ji ignorují, takže
 * z pokladny nabídky se do jejích položek zapsat nedá.
 *
 * Z adresy, ne ze stavu: hlavička platí přesně tak dlouho, dokud je
 * zákazník na stránce pokladny nabídky, a nic se nemusí uklízet.
 */

/** Hlavička, kterou čte backend. Drž ve shodě s ``QUOTE_CHECKOUT_HEADER``. */
export const QUOTE_CHECKOUT_HEADER = "X-Quote-Checkout";

const QUOTE_PARAM = "quote";

/** Odkaz na pokladnu nabídky. */
export function quoteCheckoutPath(lang: string, publicId: string): string {
  return `/${lang}/checkout?${QUOTE_PARAM}=${encodeURIComponent(publicId)}`;
}

/** Veřejné id nabídky, ze které se právě objednává, jinak ``null``. */
export function currentQuoteCheckout(): string | null {
  try {
    const { pathname, search } = window.location;
    if (!/^\/[^/]+\/checkout\/?$/.test(pathname)) return null;
    return new URLSearchParams(search).get(QUOTE_PARAM) || null;
  } catch {
    return null;
  }
}

/**
 * Klíč react-query košíku/pokladny rozšířený o nabídku, ze které se
 * objednává — aby se položky nabídky nepromíchaly s košíkem v cache.
 * Mimo pokladnu nabídky vrací klíč beze změny.
 */
export function withQuoteCheckoutScope<T extends readonly unknown[]>(
  key: T,
): readonly unknown[] {
  const quote = currentQuoteCheckout();
  return quote ? [...key, { quoteCheckout: quote }] : key;
}
